import type { StoragePool } from "@warrenio/api-spec/spec.oats.gen";

export const defaultStoragePoolUuid = "99f86dfe-e055-6666-8335-5544e6597aed";
export const fasterStoragePoolUuid = "00000000-12dd-48d3-a545-30b3ef8889e6";
export const extremeStoragePoolUuid = "57a219ef-83fd-412c-8b6a-953ac292bc37";

export const adminStoragePoolExample: StoragePool[] = [
    {
        uuid: extremeStoragePoolUuid,
        created_at: "2023-10-24T13:52:58.918+0000",
        is_default: true,
        conf: '{"osImagesPath": "vm-os-images"}',
        percent_used: 81.44,
        ceph_fsid: "00000000-12dd-48d3-a545-30b3ef8889e6",
        display_name: "Extreme",
        total_gb: 10800,
        pool_name: "disk-images",
        stored_gb: 6500,
    },
    {
        uuid: defaultStoragePoolUuid,
        created_at: "2023-10-24T13:52:58.918+0000",
        is_default: true,
        conf: '{"osImagesPath": "vm-os-images"}',
        percent_used: 67.74896,
        ceph_fsid: "00000000-12dd-48d3-a545-30b3ef8889e6",
        display_name: "Default",
        total_gb: 8800,
        pool_name: "disk-images",
        stored_gb: 5500,
    },
    {
        uuid: fasterStoragePoolUuid,
        created_at: "2023-10-24T13:52:58.918+0000",
        is_default: true,
        conf: '{"osImagesPath": "vm-os-images"}',
        percent_used: 23.34,
        ceph_fsid: "00000000-12dd-48d3-a545-30b3ef8889e6",
        display_name: "Faster",
        total_gb: 24800,
        pool_name: "disk-images",
        stored_gb: 11000,
    },
];
